import { unescapeHTML } from '../../helpers/helpers';

export class LabelsStore {

  constructor(labelsObj) {
    for (let label in labelsObj) {
      if(labelsObj.hasOwnProperty(label)) {
        labelsObj[label] = unescapeHTML(labelsObj[label]);
      }
    }

    Object.assign(this, labelsObj);
  }
}
